import { render, staticRenderFns } from "./fileDone.vue?vue&type=template&id=30b3a6e2"
import script from "./fileDone.vue?vue&type=script&lang=js"
export * from "./fileDone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports